import React, { useState } from "react";
import { vendor_page_labels } from "../../../Constants/Labels";
import ImagesPreview from "../../ImagesPreview/ImagesPreview";
import RichTextEditor from "../../Global/RichTextEditor/RichTextEditor";
import "./FeaturedProductsBlock.css";

const ProductsBlock = ({ 
    onRemove,
    id
    
}) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleSave = () => {
        setIsEditing(false);
    };

    const handleCancel = () => {
        setIsEditing(false);
    };

    return (
        <div className="block-container">
            <div className="block-header">
                <h4 className="block-title">Product Section</h4>
                <div className="block-actions">
                    <button className="block-action-btn remove" onClick={onRemove}>
                        <span className="mdi mdi-delete"></span> Remove
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductsBlock;
